import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import { useForm } from 'react-hook-form';
import { DynamicSelect } from "../../components/DynamicSelect";
import { StldRow } from "../../styled-components/StldRow.style";
import { StldColumn } from "../../styled-components/StldColumn.style";
import { StyledTableDentroDoCard } from "../../styled-components/StyledTableDentroDoCard.style";
import Swal from "sweetalert2";
import { DynamicInput } from "../../components/DynamicInput";

export const ModalOrdenDeServicoEdicao = (
    { 
        empresaList, 
        clientList, 
        isOpen, 
        onAfterOpen, 
        onRequestClose, 
        loadOrdens, 
        selectedOrdemDeServico 
    }) => {
    const [selectedEmpresa, setselectedEmpresa] = useState(null);
    const [idEmpresa, setEmpresaId] = useState([]);
    const { register, handleSubmit, reset } = useForm();
    const [cliente, setCliente] = useState(null);
    const [idCliente, setIdCliente] = useState(null);
    const [numeroOC, setNumeroOC] = useState(null);
    const submitButtonRef = useRef(null)
    const [ListaData, setListaData] = useState(null);
    const [tsSelecionados, setTsSelecionados] = useState([]);
    const [loadingData, setLoadingData] = useState(false);

    useEffect(() => {
        if(selectedOrdemDeServico?.ordemServico?.cliente?.idCliente) {
            getCliente("", selectedOrdemDeServico?.ordemServico?.cliente?.idCliente)
            getEmpresa("", selectedOrdemDeServico?.ordemServico?.empresa?.idEmpresa)
            setTsSelecionados(selectedOrdemDeServico?.timesheets)
            setNumeroOC(selectedOrdemDeServico?.ordemServico?.numeroOC || "")
        }
    }, [selectedOrdemDeServico])

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%',
            maxWidth: '100%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const getCliente = (currentValue, value) => {
        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });

        var cliente = clienteResult[0].cliente;
        var idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getEmpresa = (currentValue, value) => {
        var statusResult = empresaList.filter(function (o) {
            return o.idEmpresa == value;
        });

        var status = statusResult[0].description;
        var idEmpresa = statusResult[0].idEmpresa;
        setselectedEmpresa(status);
        setEmpresaId(idEmpresa);
    };

    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const formSubmit = async (data) => {
        if(idCliente && idEmpresa) {
            let params = "";
            params += `IdCliente=${idCliente}`;
            params += `&IdEmpresa=${idEmpresa}`;
    
            setListaData(null);
            setLoadingData(true);
            const response = await api.get(`OrdemDeServico/timesheets?${params}`);
            var data = response.data;
            data.data = [...data.data, ...selectedOrdemDeServico.timesheets.map(ts => {
                ts["checked"] = true
                return ts
            })]
            setListaData(data);
            setLoadingData(false);
        }
    }

    const [totalHoras, setTotalHoras] = useState(0);
    const [totalValor, settotalValor] = useState(0);

    useEffect(() => {
        let totalHoras = 0;
        let totalValor = 0;
        tsSelecionados.forEach((tsItem) => {
            totalHoras += tsItem.totalHorasFaturadas;
            totalValor += tsItem.valorTotalFaturado;
        });
        setTotalHoras(totalHoras);
        settotalValor(totalValor);

        var data = {
            data: tsSelecionados.map(ts => {
                ts["checked"] = true
                return ts
            })
        }
        setListaData(data)

    }, [tsSelecionados])

    const addRemoveTS = (event, item) => {
        const isChecked = event.target.checked;

        if(isChecked) {
            setTsSelecionados([...tsSelecionados, item])
        }
        else {
            setTsSelecionados([...tsSelecionados.filter(ts=> ts.idTimesheet != item.idTimesheet)])
        }
        item["checked"] = isChecked
    }

    const editarOrdem = async (integrar) => {
        let body = {
            idOrdemServico: selectedOrdemDeServico.ordemServico.idOrdemServico,
            idCliente: idCliente,
            integrar: integrar,
            IdTimesheet: tsSelecionados.map(ts => ts.idTimesheet),
            NumeroOC: numeroOC
        }
        try {
            Swal.showLoading()
            const response = await api.put(`OrdemDeServico`, body);
            var msg = ""

            if(integrar)
                msg = "Ordem de serviço integrada com sucesso!"
            else
                msg = "Ordem de serviço editada com sucesso!"
            Swal.fire({
                title: "Sucesso",
                text: msg,
                icon: "success",
                timer: 2500,
                showConfirmButton: true,
            });
            loadOrdens(null, 0, 10)
            onRequestClose()
        } catch (error) {
            var errorMsg = "";
            if(error?.response?.data?.notification?.messageReturn)
                errorMsg = error.response.data.notification.messageReturn;
            else
                errorMsg = "Ops, ocorreu um erro ao realizar o cadastro. Entre em contato com um de nossos administradores e informe o erro.";

            Swal.fire({
                title: "Atenção",
                text: errorMsg,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Histórico"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <StyledForm onSubmit={handleSubmit(formSubmit)}>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <p className="modal-title">Editar Ordem de Serviço</p>
                        </div>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <div className="position-relative form-group col-sm-12 col-sm-12 col-md-12 col-lg-12 p-2 header-select">
                        <DynamicSelect 
                            placeholder={''}
                            valuetext={selectedEmpresa}
                            label={'Selecione a empresa'}
                            name={'idEmpresa'}
                            options={empresaList}
                            keyValue={'idEmpresa'}
                            keyLabel={'description'}
                            paramMethod={getEmpresa}
                            disabled={true} />
                    </div>
                </Flex>
                <Flex>
                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2 header-select">
                        <DynamicSelect 
                            placeholder={''} 
                            valuetext={cliente} 
                            label={'Selecione o cliente'} 
                            name={'idCliente'} 
                            options={clientList} 
                            keyValue={'idCliente'} 
                            keyLabel={'cliente'} 
                            paramMethod={getCliente} 
                            disabled={true} />
                    </div>
                </Flex>
                {/* <Flex>
                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2 header-select">
                        <DynamicInput
                            type={"text"}
                            label={"OC"}
                            name={"OC"}
                            value={numeroOC}
                            paramMethod={(value) => setNumeroOC(value)}
                        />
                    </div>
                </Flex> */}
                <Flex>
                    {loadingData ? 
                        <StldRow>
                            <div className="text-center">
                                <div className="align-items-center">
                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                    <div><strong style={{ color: "#EE4B21" }}>{'Atualizando...'}</strong></div>
                                </div>
                            </div>
                        </StldRow > : 
                    ''}
                    {
                       ListaData != null && ListaData?.data.length > 0 && (
                            <StldColumn xs="12" sm="12" md="12" lg="12" xl="12">
                                <StyledTableDentroDoCard>
                                    <div style={{fontSize: "13px"}} className="text-center"> Timesheets </div>
                                    <div className="table-responsive">
                                        <table className="table table-sm mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Selecionar</th>
                                                    <th>Sigla</th>
                                                    <th>TS</th>
                                                    <th>Segurado</th>
                                                    <th>Total Horas</th>
                                                    <th>Valor Total</th>
                                                    <th className="text-center">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                ListaData != null && ListaData?.data?.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th scope="row">
                                                                <input type="checkbox" id="" onChange={(e) => addRemoveTS(e, item)} checked={item?.checked} />
                                                            </th>
                                                            <th scope="row" className="text-nowrap">{item.sigla}</th>
                                                            <td className="text-nowrap">{item.timeSheetSigla}</td>
                                                            <td  title={item.segurado.nome}>
                                                                <div className="ellipse-height">
                                                                    {item.segurado.nome}
                                                                </div>
                                                            </td>
                                                            <td className="text-nowrap">{formatDecimal(item.totalHorasFaturadas)}</td>
                                                            <td className="text-nowrap">{formatCurrency(item.valorTotalFaturado)}</td>
                                                            <td className="text-center">
                                                                <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: item.idTimesheet }}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                                        <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                                        <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                                    </svg>
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </StyledTableDentroDoCard>
                            </StldColumn>
                        )
                    }
                </Flex>
                <Flex>
                    <div className={`form-wrapper filter-container m-0`} style={{width: "100%"}}>
                        <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 text-center mt-3">
                            <input type="submit" className='default-button-red' value='Pesquisar' ref={submitButtonRef} />
                        </div>
                    </div>
                </Flex>
            </StyledForm>
            <StldColumn xs="12" sm="12" md="12" lg="12" xl="12">
                <StldRow>
                    <StldColumn xs="12" sm="12" md="12" lg="12" xl="12">
                        <StyledTableDentroDoCard>
                            <div style={{fontSize: "13px"}} className="text-center"> TS Selecionados </div>
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th>Sigla</th>
                                            <th>TS</th>
                                            <th>Segurado</th>
                                            <th>Total Horas</th>
                                            <th>Valor Total</th>
                                            <th className="text-center">Visualizar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        tsSelecionados != null && tsSelecionados.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th scope="row">{item.sigla}</th>
                                                    <td>{item.timeSheetSigla}</td>
                                                    <td>{item.segurado.nome}</td>
                                                    <td>{formatDecimal(item.totalHorasFaturadas)}</td>
                                                    <td>{formatCurrency(item.valorTotalFaturado)}</td>
                                                    <td className="text-center">
                                                        <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: item.idTimesheet }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16" style={{color: "#007bff"}}>
                                                                <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                                <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                            </svg>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td className="text-center" colSpan={3}>Total</td>
                                            <td>{formatDecimal(totalHoras)}</td>
                                            <td>{formatCurrency(totalValor)}</td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </StyledTableDentroDoCard>
                    </StldColumn>
                </StldRow>
            </StldColumn>
            
            <StyledForm>
                <div className={`form-wrapper filter-container mt-2`} style={{width: "100%"}}>
                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 text-center mt-3">
                        <input type="button" className='default-button-red' value='Editar Ordem de Serviço' onClick={() => editarOrdem(false)} />
                        <input type="button" className='default-button-red ml-1' value='Editar e Integrar Ordem de Serviço'  onClick={() => editarOrdem(true)} />
                    </div>
                </div>
            </StyledForm>
        </Modal>
    );
};